import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { BASE_URL } from '../components/constants';

// Async thunk for fetching support settings
export const fetchSupportSettings = createAsyncThunk(
  'supportSettings/fetchSupportSettings',
  async () => {
    const response = await axios.get(`${BASE_URL}/support-settings`);
    return response.data;
  }
);

// Async thunk for updating support settings
export const updateSupportSettings = createAsyncThunk(
  'supportSettings/updateSupportSettings',
  async ({ information_text, feedback_link }) => {
    const formData = new FormData();
    formData.append('information_text', information_text);
    formData.append('feedback_link', feedback_link);
    
    const response = await axios.post(`${BASE_URL}/support-settings`, formData);
    return response.data;
  }
);

const supportSettingsSlice = createSlice({
  name: 'supportSettings',
  initialState: {
    information_text: '',
    feedback_link: '',
    loading: false,
    error: null,
    lastUpdated: null,
  },
  reducers: {
    clearSupportSettings: (state) => {
      state.information_text = '';
      state.feedback_link = '';
      state.error = null;
    },
    setInformationText: (state, action) => {
      state.information_text = action.payload;
    },
    setFeedbackLink: (state, action) => {
      state.feedback_link = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSupportSettings.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSupportSettings.fulfilled, (state, action) => {
        state.loading = false;
        state.information_text = action.payload.information_text || '';
        state.feedback_link = action.payload.feedback_link || '';
        state.lastUpdated = action.payload.updated_at;
      })
      .addCase(fetchSupportSettings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(updateSupportSettings.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateSupportSettings.fulfilled, (state) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(updateSupportSettings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const { clearSupportSettings, setInformationText, setFeedbackLink } = supportSettingsSlice.actions;
export default supportSettingsSlice.reducer;
